import Api from '.';

class WorkObjectApi extends Api {
  base_endpoint = 'work-objects';

  deleteFromTask(job_id) {
    return this.doRequest('delete', `${job_id}/pending`);
  }

  allByStatus({ job_id, status }, params) {
    return this.doRequest('get', `report/${job_id}/${status}`, { params });
  }
}

export default new WorkObjectApi();
